import {
  Body,
  Box,
  Container,
  Heading,
  Icon,
  SimpleGrid,
  VStack,
} from '@hover/blueprint';
import { iCloudRain, iSun } from '@hover/icons';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

const SlideDesktop: React.FC = () => (
  <SimpleGrid
    d={{ base: 'none', desktop: 'grid' }}
    columns={2}
    spacing="60px"
    alignItems="center"
    w="100%"
  >
    <VStack spacing="54px" alignItems="flex-start" alignSelf="flex-start">
      <Box flexDir="column" maxW="560px">
        <Box flexDir="row" alignItems="center" mb={200} pb={100}>
          <Icon
            size="default"
            mr={400}
            icon={iCloudRain}
            color="brandNavy.500"
          />
          <Body size={200} isBold color="brandNavy.500" as="h4">
            PROBLEM
          </Body>
        </Box>
        <Heading size={500} isDisplay marginBottom={0} as="p" color="#333">
          For high ticket jobs, they needed a tool to help them build a
          reputation for design and inspire homeowner confidence.
        </Heading>
      </Box>
      <Box flexDir="column" maxW="584px">
        <Box flexDir="row" alignItems="center" mb={200} pb={100}>
          <Icon size="default" mr={400} icon={iSun} color="brandNavy.500" />
          <Body size={200} isBold color="brandNavy.500" as="h4">
            SOLUTION
          </Body>
        </Box>
        <Heading size={500} isDisplay marginBottom={0} as="p" color="#333">
          With HOVER Design Orders, Colorado Siding Repair increased their close
          rate from 25% to 50%. They now offer a photorealistic HOVER Rendering
          to every homeowner lead to help them see the possibilities of their
          home.
        </Heading>
      </Box>
    </VStack>
    <Container flexDir="column" maxW="556px" px={0}>
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        alt="real time 3d"
        objectFit="contain"
        src="../../../assets/images/design_orders_testimonial_1.png"
      />
      <Box
        p={400}
        w="100%"
        bg="brandNavy.500"
        mt={200}
        borderRadius="0 0 8px 8px"
        dropShadow="medium"
        flexDir="column"
      >
        <Body
          size={500}
          lineHeight="24px"
          color="neutral.0"
          isSemiBold
          mb="10px"
        >
          “Every customer is worthy of this design experience. We use it to grab
          the homeowner’s attention, get them excited, and provide ideas. We
          also use it to clearly define the scope of the project that we’ve
          agreed upon.”
        </Body>

        <Body fontSize="12px" lineHeight="16px" color="neutral.0">
          Stephen Chismarich
        </Body>
        <Body fontSize="12px" lineHeight="16px" color="neutral.0">
          Director of Sales and Business Development
        </Body>
      </Box>
    </Container>
  </SimpleGrid>
);

export default SlideDesktop;
